import { gql } from '@apollo/client'

export const EXPORT_COMPONENT_TAXONOMY_QUERY = gql`
  query TaxonomyPackagingComponents(
    $first: Int
    $after: String
    $where: TaxonomyPackagingComponentsGraphQLFilterInput
    $order: [TaxonomyPackagingComponentsGraphQLSortInput!]
  ) {
    taxonomyPackagingComponents(first: $first, after: $after, where: $where, order: $order) {
      nodes {
        id
        code
        state
        name
        alias
        isVerified
        verifiedOn
        verifiedByName
        verifiedByEmail
        verificationComments
        researcherName
        researcherEmail
        created
        updated
        userEmail
        lastUpdatedName
        lastPublishedDate
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`
